// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2-auH","buttons":"PendingPaymentAlert_buttons__BU1mW"};